// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoText_root__j5M6r"};